<template>
  <div>
    <div
      class="text-center loader"
      v-if="loader"
    >
      <spiner />
    </div>
    <div v-else>
      <div>
        <div
          style="position:relative"
          :style="menuCols"
        >
          <Sidebar />
        </div>
        <div
          class="content"
          :style="contentCols"
        >
          <Navbar />
          <div class="wrapper">
            <div class="container-dashboard">
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Navbar from '@/components/organisms/navbar/index.vue';
import Sidebar from '@/components/organisms/sidebar/index.vue';
import Spiner from '@/components/atoms/loader/index.vue';
import EventBus from '../../../eventBus';

export default {
  name: 'Webapp',
  components: {
    Navbar,
    Sidebar,
    Spiner,
  },

  data: () => ({
    userAuth: null,
    loader: false,
    contentCols: {
      width: 'calc(100% - 280px)',
      marginLeft: '280px',
    },
    menuCols: {
      width: '280px',
    },
  }),

  methods: {
    ...mapActions('auth', ['verifyToken']),
  },

  async created() {
    // this.loader = true;
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
  },

  async mounted() {
    if (!this.userAuth) {
      localStorage.setItem('_pbiAssobens', null);
      this.$router.push('/login');
    }

    // eslint-disable-next-line
    EventBus.$on('collapse', (param) => {
      if (param) {
        this.contentCols.width = 'calc(100% - 70px)';
        this.contentCols.marginLeft = '70px';
        this.menuCols.width = '70px';
      } else {
        this.contentCols.width = 'calc(100% - 280px)';
        this.contentCols.marginLeft = '280px';
        this.menuCols.width = '280px';
      }
    });

    await this.verifyToken(this.userAuth.token)
      // eslint-disable-next-line
      .then((response) => {
        if (response) {
          this.loader = false;
        } else {
          this.$router.push('/');
        }
      })
      .catch(() => {
        this.loader = false;
        this.$router.push('/login');
      });
  },
};
</script>

<style lang="scss">
.loader {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-container {
  background: -webkit-linear-gradient(0deg, #202020, #404040 100%);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1;
  pointer-events: none;
  height: 330px;
}
.content {
  transition: all 0.2s linear;
  // height: 100vh;
  overflow: hidden;
}
.container-dashboard {
  background-color: #fafafa;
  height: calc(100vh - 75px);
  padding: 10px;
}
.v-sidebar-menu .vsm--list {
  margin-top: 0px;
}
</style>
